import { render } from "./BalanceHistory.vue?vue&type=template&id=23285ac2"
import script from "./BalanceHistory.vue?vue&type=script&lang=js"
export * from "./BalanceHistory.vue?vue&type=script&lang=js"

import "./BalanceHistory.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__